import DotPagination from "./component-library43.mjs";
import PlayPauseButton from "./component-library14.mjs";
import ForwardBackwardButton from "./component-library15.mjs";
const _sfc_main = {
  components: {
    DotPagination,
    PlayPauseButton,
    ForwardBackwardButton
  },
  props: {
    autoplay: { type: Number, default: 5e3 },
    startSlide: { type: Number, default: 0 },
    transitionDuration: { type: Number, default: 400 },
    pauseOnHover: { type: Boolean, default: true }
  },
  data() {
    return {
      activeSliderIndex: this.startSlide,
      timeout: null,
      transitionTimeout: null,
      sliderTransition: this.transitionDuration,
      isMouseOver: false,
      isPlaying: this.autoplay > 0
    };
  },
  computed: {
    slides() {
      return this.$slots.default ? this.$slots.default.filter((entry) => entry.tag) : [];
    },
    slideCount() {
      return this.slides.length;
    },
    transform() {
      return `${-100 * this.activeSliderIndex}%`;
    },
    sliderClass() {
      var _a, _b, _c;
      return [((_c = (_b = (_a = this.slides[this.activeSliderIndex]) == null ? void 0 : _a.data) == null ? void 0 : _b.attrs) == null ? void 0 : _c["data-slider-class"]) || ""].join(
        "; "
      );
    },
    sliderStyles() {
      var _a, _b, _c;
      return [
        `--slide-count: ${this.slideCount}`,
        `--slider-transition: ${this.sliderTransition}ms`,
        `--slider-translate: ${this.transform}`,
        ((_c = (_b = (_a = this.slides[this.activeSliderIndex]) == null ? void 0 : _a.data) == null ? void 0 : _b.attrs) == null ? void 0 : _c["data-slider-styles"]) || ""
      ].join("; ");
    },
    pages() {
      const pagination = [];
      for (let i = 0; i < this.slideCount; i += 1) {
        pagination.push({ number: i, active: i === this.activeSliderIndex });
      }
      return pagination;
    }
  },
  watch: {
    activeSliderIndex(newIndex, oldIndex) {
      var _a, _b;
      if (oldIndex !== void 0 && ((_a = this.slides[oldIndex]) == null ? void 0 : _a.componentInstance)) {
        this.slides[oldIndex].componentInstance.isActiveSlide = false;
      }
      if ((_b = this.slides[newIndex]) == null ? void 0 : _b.componentInstance) {
        this.slides[newIndex].componentInstance.isActiveSlide = true;
      }
    },
    isPlaying(value) {
      if (value) {
        this.startTimeout();
      } else if (this.timeout) {
        clearTimeout(this.timeout);
      }
    }
  },
  mounted() {
    var _a;
    if ((_a = this.slides[this.activeSliderIndex]) == null ? void 0 : _a.componentInstance) {
      this.slides[this.activeSliderIndex].componentInstance.isActiveSlide = true;
    }
    if (this.slideCount <= 1)
      return;
    if (this.activeSliderIndex < 0 || this.activeSliderIndex >= this.slideCount) {
      this.activeSliderIndex = 0;
    }
    this.startTimeout();
  },
  beforeUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    if (this.transitionTimeout) {
      clearTimeout(this.transitionTimeout);
    }
  },
  methods: {
    animateSlides(newActiveSliderIndex) {
      if (this.transitionTimeout) {
        clearTimeout(this.transitionTimeout);
      }
      const difference = Math.abs(this.activeSliderIndex - newActiveSliderIndex);
      if (difference === 1) {
        this.sliderTransition = this.transitionDuration;
      } else {
        this.sliderTransition = this.transitionDuration * 2;
      }
      this.activeSliderIndex = Math.min(newActiveSliderIndex, this.slideCount - 1);
      this.transitionTimeout = setTimeout(() => {
        this.startTimeout();
      }, this.transitionDuration);
    },
    selectSlide(slide) {
      if (slide === this.activeSliderIndex)
        return;
      this.animateSlides(slide);
    },
    changeSlide(direction) {
      const nextSlideIndex = (this.activeSliderIndex + direction + this.slideCount) % this.slideCount;
      this.animateSlides(nextSlideIndex);
    },
    startTimeout() {
      if (!this.isPlaying)
        return;
      if (this.isMouseOver && this.pauseOnHover)
        return;
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      if (this.slideCount > 1 && this.autoplay > 0) {
        this.timeout = setTimeout(() => this.changeSlide(1), this.autoplay);
      }
    },
    hoverEnter() {
      this.isMouseOver = true;
      if (this.pauseOnHover && this.isPlaying && this.timeout) {
        clearTimeout(this.timeout);
      }
    },
    hoverLeave() {
      this.isMouseOver = false;
      if (this.pauseOnHover && this.isPlaying) {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        this.startTimeout();
      }
    }
  }
};
export {
  _sfc_main as default
};
